<template>
    <div class="help_wrapper">
        <div class="help_container_wrapper">
            <div class="help_nav_top">
                高级检索帮助
            </div>
            <div class="help_cons_center">
                <div class="left_expan">
                    <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel key="0">
                            <v-expansion-panel-header>
                                <div class="flex_style left">
                                    <div class="icon edit"></div>
                                    <div class="text">被忽略的信息录入技巧</div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="list_wrapper">
                                    <div class="list_item" :class="{'active': activeKey == 1}" @click="activeKey = 1">关键词是否加引号的区别</div>
                                    <div class="list_item" :class="{'active': activeKey == 2}" @click="activeKey = 2">名称地址的选择</div>
                                    <div class="list_item" :class="{'active': activeKey == 3}" @click="activeKey = 3">IPC助手的使用</div>
                                    <div class="list_item" :class="{'active': activeKey == 4}" @click="activeKey = 4">其他正在更新</div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel key="1">
                            <v-expansion-panel-header>
                                <div class="flex_style left">
                                    <div class="icon"></div>
                                    <div class="text">简易精准的逻辑运算</div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="list_wrapper">
                                    <div class="list_item" :class="{'active': activeKey == 5}" @click="activeKey = 5">与或非的使用规则</div>
                                    <div class="list_item" :class="{'active': activeKey == 6}" @click="activeKey = 6">括号的使用规则</div>
                                    <div class="list_item" :class="{'active': activeKey == 7}" @click="activeKey = 7">其他正在更新</div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
                <div class="right_cons">
                    <div class="cons_text_wrapper" v-if="activeKey == 1">
                        <div class="tit">关键词是否加引号的区别</div>
                        <div class="tit1">一.关键词不加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                        <div class="tit1">二.关键词加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                    </div>
                    <div class="cons_text_wrapper" v-if="activeKey == 2">
                        <div class="tit">名称地址的选择</div>
                        <div class="tit1">一.关键词不加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                        <div class="tit1">二.关键词加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                    </div>
                    <div class="cons_text_wrapper" v-if="activeKey == 3">
                        <div class="tit">IPC助手的使用</div>
                        <div class="tit1">一.关键词不加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                        <div class="tit1">二.关键词加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                    </div>
                    <div class="cons_text_wrapper" v-if="activeKey == 4">
                        <div class="tit">其他正在更新，敬请期待</div>
                    </div>
                    <div class="cons_text_wrapper" v-if="activeKey == 5">
                        <div class="tit">与或非的使用规则</div>
                        <div class="tit1">一.关键词不加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                        <div class="tit1">二.关键词加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                    </div>
                    <div class="cons_text_wrapper" v-if="activeKey == 6">
                        <div class="tit">括号的使用规则</div>
                        <div class="tit1">一.关键词不加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                        <div class="tit1">二.关键词加引号</div>
                        <div class="lis_wrapper">
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">输入框内输入关键词：印制线路板。</div>
                            </div>
                            <div class="lis_item">
                                <div class="circle"></div>
                                <div class="text">点击“搜索”按钮，查看检索结果页专利搜索条数是10810条。</div>
                            </div>
                        </div>
                        <div class="img_box">
                            <img src="../../assets/images/help/help1.svg" alt="">
                        </div>
                    </div>
                    <div class="cons_text_wrapper" v-if="activeKey == 7">
                        <div class="tit">其他正在更新，敬请期待</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            panel: [0,1],
            activeKey: 1
        }
    },
    created() {

    }
}
</script>